import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAdminAuth } from './hooks/useAdminAuth';
import Layout from './components/Layout';
import Users from './pages/Users';
import UsageStats from './pages/UsageStats';
import UnsupportedRequests from './pages/UnsupportedRequests';
import Login from './pages/Login';

function App() {
  const { user, isAdmin, loading } = useAdminAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-primary mx-auto"></div>
          <p className="mt-4 text-neutral-secondary">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user || !isAdmin) {
    return <Login />;
  }

  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Navigate to="/users" replace />} />
          <Route path="/users" element={<Users />} />
          <Route path="/usage" element={<UsageStats />} />
          <Route path="/unsupported-requests" element={<UnsupportedRequests />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
